import Caption from "./Caption";
import Photo from "./Photo";

const HeroWrapper = ({heroInformation, socialMedias}) => {
    return(
        <div className={'container mx-auto px-6 lg:px-8'}>
            <div className={'grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center min-h-screen py-12'}>
                <div className={'order-2 lg:order-1'}>
                    <Caption cv={heroInformation?.cv} jobName={heroInformation?.jobName} fullName={heroInformation?.fullName} socialMedias={socialMedias} captionHero={heroInformation?.captionHero} />
                </div>
                <div className={'order-1 lg:order-2 flex justify-center lg:justify-end'}>
                    <Photo photoProfile={heroInformation?.photoUrl} />
                </div>
            </div>
        </div>
    )
}
export default HeroWrapper;